import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

class PromoSlider {

  constructor(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    this.root = node;
    this.swiper = this.root.querySelector('.promo-banner .swiper');
    //this.nextEl = this.root.querySelector('.promo-banner__inner__nav.next');
    //this.prevEl = this.root.querySelector('.promo-banner__inner__nav.prev');


    this._init();
  }

  _init() {

    Swiper.use([Autoplay, Navigation]);

    new Swiper(this.swiper, {
      slidesPerView: 1,
      direction: 'horizontal',
      speed: 1500,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      //navigation: {
        //nextEl: this.nextEl,
        //prevEl: this.prevEl,
      //},
    });

  }
}

[...document.querySelectorAll('.promo-banner')].forEach(node => {
  new PromoSlider(node);
});